/**
 * Carousel Palette Utility
 *
 * Provides per-slide background/foreground color cycling using CSS custom properties.
 * Each brand defines --carousel-slide-N and --carousel-slide-N-foreground in its stylesheet.
 *
 * @see brands/{brand}/styles/{brand}.css for palette definitions
 * @see app/components/shared/diagram/diagramTheme.ts for similar pattern
 */

/** Number of palette slots defined in each brand's CSS */
const CAROUSEL_PALETTE_SIZE = 5

/**
 * Returns inline style object for a carousel slide at the given index.
 * Cycles through the brand's palette using modulo.
 */
export function getCarouselSlideStyle(index: number): React.CSSProperties {
	const slot = index % CAROUSEL_PALETTE_SIZE
	return {
		backgroundColor: `var(--carousel-slide-${slot})`,
		color: `var(--carousel-slide-${slot}-foreground)`,
	}
}

/**
 * Returns the CSS variable name for a carousel slide background at the given index.
 */
export function getCarouselSlideBg(index: number): string {
	const slot = index % CAROUSEL_PALETTE_SIZE
	return `var(--carousel-slide-${slot})`
}

/**
 * Returns the CSS variable name for a carousel slide foreground at the given index.
 */
export function getCarouselSlideFg(index: number): string {
	const slot = index % CAROUSEL_PALETTE_SIZE
	return `var(--carousel-slide-${slot}-foreground)`
}

export { CAROUSEL_PALETTE_SIZE }
